module.exports = __webpack_public_path__ + "img/icon-radar.db1e5a79.svg";